import { createTheme } from '@material-ui/core/styles';

export const darkTheme = createTheme({
  palette: {
    text: {
      color: 'red',
    },
    type: 'dark',
    primary: {
      main: '#65C988',
    },
    error: {
      main: '#c66065',
    },
    className: {
      className1: 'dark_btn',
      className2: 'button__bar blue_dot',
    },
    background: {
      main: '#000',
      darkBg: 'linear-gradient(90deg, #0065ff, #6942ef, #6554c0, #008cff, #0065ff, #6942ef)',
      hoverBg: 'linear-gradient(90deg, #0065ff, #6942ef, #6554c0, #008cff, #0065ff, #6942ef);',
      hoverBgPay: 'linear-gradient(to right, #2E62FF 26.2%, #4B24DC 100%)',
      transparentBg: 'transparent',
      primary: '#121212',
      btnText: 'linear-gradient(132.87deg, #ffffff -15.97%, #ffffff 5.43%, #ffffff 97.45%)',
      secondary: '#292929',
      secondary2: '#000',
      tabsBg: 'linear-gradient(91.33deg, #2E62FF 19.49%, #4A28DE 88.25%)',
      nTabsBg: 'linear-gradient(91.33deg, #2E62FF 19.49%, #4A28DE 88.25%)',
      input: '#000',
      // dialog: '#0A0A0A',
      dialog: '#1A1A1A',
      disabled: '#2F2F2F',
      hover: '#00000080',
      overlay: 'rgba(0,0,0,0.6)',
    },
    text: {
      primary: '#fff',
      secondary: '#C5C5C5',
      disabled: '#C5C5C5',
      placeholder: '#606060',
      title: '#fff',
      light: '#fff',
      lightBtn: '#fff',
      hoverWhite: '#fff',
      textFillColor: 'unset',
    },
    borderType: {
      border1: '0',
    },
    border: {
      lightBorder: '#333',
      lightColor: 'transparent',
      tabsActiveBorder: '#ccc',
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },
});

export const lightTheme = createTheme({
  palette: {
    text: {
      color: 'orange',
    },
    type: 'light',
    primary: {
      main: '#65C988',
    },
    error: {
      main: '#c66065',
    },
    className: {
      className1: 'light_btn',
      className2: 'button__bar golden_dot',
    },
    // #EEEEEE 12.72%
    background: {
      main: '#F5F5F5',
      hoverBg: 'linear-gradient(to right, #D4C78C 21.39%, #DEBF70 34.64%, #AE9555 44.61%, #A78C47 57.04%)',
      hoverBgPay: 'linear-gradient(to right, #D4C78C 21.39%, #DEBF70 34.64%, #AE9555 44.61%, #A78C47 57.04%)',
      primary: '#fff',
      btnText: 'linear-gradient(132.87deg, #FFF4D1 -15.97%, #F5D28F 5.43%, #675537 97.45%)',
      btnText: 'linear-gradient(to right, #FFF4D1 -15.97%, #F5D28F 5.43%, #675537 97.45%)',
      darkBg: 'linear-gradient(#131313,#131313)',
      transparentBg: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%)',
      secondary: '#F5F5F5',
      input: '#F5F5F5',
      dialog: '#fff',
      secondary2: '#fff',
      tabsBg: '#131313',
      nTabsBg: 'linear-gradient(to right, #D4C78C 21.39%, #DEBF70 34.64%, #AE9555 44.61%, #A78C47 57.04%)',
      disabled: '#E2E2E2',
      hover: '#E5E5E5',
      overlay: 'rgba(0,0,0,0.6)',
    },
    text: {
      primary: '#000',
      secondary: '#666',
      disabled: '#B2B2B2',
      placeholder: '#B8B8B8',
      title: '#787A97',
      light: '#F5D28F',
      lightBtn: '#000',
      hoverWhite: '#fff',
      textFillColor: 'transparent',
    },
    borderType: {
      border1: '1px solid',
    },
    border: {
      lightBorder: '#E7E8EA',
      lightColor: '#F5D28F',
      tabsActiveBorder: '#F5D28F',
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },
});
